import styled from '@xstyled/styled-components';

export const Card = styled.divBox`
  box-sizing: border-box;
  position: relative;
  box-shadow: 0px -2px 4px rgba(0, 0, 0, 0.05),
    0px 30px 30px rgba(0, 0, 0, 0.03), 0px 15px 20px rgba(0, 0, 0, 0.05);
`;

Card.defaultProps = {
  bg: 'white',
  borderRadius: 'xl',
  onClick: e => e.stopPropagation()
};
